export const getAddressPredictions = (query: string) => {
    return new Promise<google.maps.places.AutocompletePrediction[] | null>(resolve => {
        const autocompleteService = new window.google.maps.places.AutocompleteService();
        autocompleteService.getPlacePredictions({ input: query, componentRestrictions: { country: 'us' } }, (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) resolve(predictions || []);
            else resolve([]);
        });
    });
};

export const getAddressDetails = (placeId: string) =>
    new Promise<google.maps.places.PlaceResult | null>(resolve => {
        const service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails({ placeId }, (place, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) resolve(place);
            else resolve(null);
        });
    });
